/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import "./ChatsList.css";
import { CustomChannelPreview } from "../customChannelPreview/CustomChannelPreview";
import { AscDesc, DefaultGenerics } from "stream-chat";
import { ChannelList } from "stream-chat-react";
import { Channel as ChannelType } from "stream-chat/dist/types/channel";
import "stream-chat-react/dist/css/v2/index.css";
import LoadingIndicator from "../../loadingIndicator/LoadingIndicator";
import { NewChatFABButton } from "../../buttons/newChatFABButton/NewChatFABButton";
import { DeleteChannelsBar } from "../../deleteChannelsBar/DeleteChannelsBar";
import { useChatClient } from "../../../hooks/useChatClient";
import { WarningModal } from "../../modal/warningModal/WarningModal";

type props = {
  handleChannelClick: (newChannel: ChannelType<DefaultGenerics>) => void;
  loading: boolean;
  handleCreateChannel: () => Promise<void>;
  setLoading: (value: boolean) => void;
  filters: {
    members: {
      $in: string[];
    };
    type: string;
  };
  options: {
    presence: boolean;
    state: boolean;
  };
  sort: {
    last_message_at: AscDesc;
  };
};

export const ChatsList: React.FC<props> = ({
  handleChannelClick,
  loading,
  handleCreateChannel,
  filters,
  options,
  sort,
  setLoading,
}) => {
  const [channelsToBeDeleted, setChannelsToBeDeleted] = useState<string[]>([]);
  const [isDeletionFailed, setIsDeletionFailed] = useState<string>("");
  const { chatClient } = useChatClient();

  const onSelectAllClicked = async () => {
    setLoading(true);
    const channels = await chatClient.queryChannels(filters, sort, {
      watch: true, // this is the default
      state: true,
    });
    setChannelsToBeDeleted(channels.map((channel) => channel.cid));
    setLoading(false);
  };

  const deleteChannels = async () => {
    setLoading(true);
    const response = await chatClient.deleteChannels(channelsToBeDeleted, {
      hard_delete: true,
    });
    const result = response.result;
    setLoading(false);
    if (Object.values(result).some((v: any) => v.status === "error")) {
      setIsDeletionFailed(
        (Object.values(result).find((v: any) => v.status === "error") as any)
          ?.error
      );
      setChannelsToBeDeleted([]);
    } else {
      setChannelsToBeDeleted([]);
    }
  };

  return (
    <div>
      {channelsToBeDeleted.length ? (
        <DeleteChannelsBar
          onDeletePress={deleteChannels}
          onCheckBoxPress={(isChecked) => {
            if (isChecked) {
              onSelectAllClicked();
            } else {
              setChannelsToBeDeleted([]);
            }
          }}
        />
      ) : null}
      <ChannelList
        filters={filters}
        sort={sort}
        options={options}
        Preview={(data) => (
          <CustomChannelPreview
            data={data}
            handleChannelClick={handleChannelClick}
            handleLongPress={(channel) => {
              setChannelsToBeDeleted((prevChannels) => {
                if (prevChannels.includes(channel.cid)) {
                  // If channelId is present, remove it
                  return prevChannels.filter((id) => id !== channel.cid);
                } else {
                  // If channelId is not present, add it
                  return [...prevChannels, channel.cid];
                }
              });
            }}
            isShowCheckBox={channelsToBeDeleted.length > 0}
            isSelected={channelsToBeDeleted.includes(data.channel.cid)}
          />
        )}
      />
      <NewChatFABButton onPress={handleCreateChannel} />
      {loading ? <LoadingIndicator loading={loading} /> : null}
      {isDeletionFailed ? (
        <WarningModal
          isOpen={!!isDeletionFailed}
          onClose={() => {
            setIsDeletionFailed("");
          }}
          title={isDeletionFailed}
        />
      ) : null}
    </div>
  );
};
